import React from 'react'
import { Link } from 'react-router-dom'
import Footer from '../components/Footer'

function InitiateWave() {
  return (
    <div className='h-[600px]'>
        <div className='m-4 flex justify-center'>
        <h1 className='font-bold text-lg'>Wave</h1>
      </div>
      <div className='flex h-[100%] flex-col justify-center space-y-3 items-center'>
        <Link to='/wave' className='px-3 py-2 rounded-xl font-semibold bg-[#D3F36B]'>Wave</Link>
        <p className='w-[190px] text-center font-semibold'>Wave to initiate conversation with anyone</p>
      </div>
      <Footer active='wave'/>
    </div>
  )
}

export default InitiateWave